import React from 'react';
import loadable from '@loadable/component';
import connectRoute from 'app/routes/connectRoute';
import RecentlyReturnedActions from 'app/actions/RecentlyReturnedActions';
import BorrowingActions from 'app/actions/BorrowingActions';
import { selectCurrentAccount } from 'app/selectors/AuthSelector';

const RecentlyReturnedContainer = loadable(() =>
  import('app/components/borrowing/recentlyreturned/RecentlyReturned/RecentlyReturnedContainer')
);

export function RecentlyReturnedPageRoute() {
  return <RecentlyReturnedContainer />;
}

function getRouteData({ dispatch, state, params, query }) {
  const account = selectCurrentAccount(state);
  const accountId = account && account.get('id');
  if (!accountId) return [];

  return [
    dispatch(BorrowingActions.fetchSummaries({ accountId })),
    dispatch(RecentlyReturnedActions.fetchReturnHistory({ accountId, ...params, ...query }))
  ];
}

export default connectRoute(RecentlyReturnedPageRoute, { getRouteData });
